<template>
  <!-- 业务管理 -->
  <div class="app-container">
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px"
        size="mini">
        <div class="formItemBox">
          <el-form-item label="业务进度:">
            <el-select v-model="searchFrom.businessProgress" placeholder="请选择订单状态" size="mini">
              <el-option label="全部" value="">全部</el-option>
              <el-option label="商务沟通" value="商务沟通">商务沟通 </el-option>
              <el-option label="协议签订" value="协议签订">协议签订 </el-option>
              <el-option label="运营进行" value="运营进行">运营进行 </el-option>
              <el-option label="订单结束" value="订单结束">订单结束 </el-option>
              <el-option label="发票开具" value="发票开具">发票开具 </el-option>
              <el-option label="回款结算" value="回款结算">回款结算 </el-option>
              <el-option label="业务完结" value="业务完结">业务完结 </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="重要度:">
            <el-input placeholder v-model="searchFrom.importance"></el-input>
          </el-form-item>
          <el-form-item label="业务员:">
            <el-input placeholder v-model="searchFrom.businessPersonnel"></el-input>
          </el-form-item>
          <el-form-item label="需方客户:">
            <el-input placeholder v-model="searchFrom.demanderCustomer"></el-input>
          </el-form-item>
          <el-form-item label="上级客户:">
            <el-input placeholder v-model="searchFrom.superiorOrderingCustomer"></el-input>
          </el-form-item>
          <el-form-item label="下级客户:">
            <el-input placeholder v-model="searchFrom.subordinateSalesCustomer"></el-input>
          </el-form-item>
          <el-form-item label="创建日期:">
            <el-date-picker v-model="searchFrom.createTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
            <!-- <el-date-picker v-model="searchFrom.createTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker> -->
          </el-form-item>

        </div>
        <div class="searchBtnBox">
          <el-button btnCode="003M4E0100" v-if="btnFlg[0]" type="primary" size="mini" @click="searchFn">查 询
          </el-button>
          <el-button btnCode="003M4E0200" v-if="btnFlg[1]" type="primary" size="mini" @click="resetForm('searchFrom')">重 置
          </el-button>
          <el-button btnCode="003M4E0300" v-if="btnFlg[2]" type="primary" size="mini" @click="addForm('searchFrom')">新 增
          </el-button>
          <el-button btnCode="003M4E0800" v-if="btnFlg[7]" type="primary" size="mini" @click="change()">修改
          </el-button>
          <el-button btnCode="003M4E0900" v-if="btnFlg[8]" type="primary" size="mini" @click="delFN()">删除
          </el-button>
          <el-button btnCode="003M4E0600" v-if="btnFlg[5]" type="primary" size="mini" @click="shangchuan()">上传凭证
          </el-button>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" @selection-change="selectGoods"
        @row-click="handleRowClick" height="100%" style="width: 100%" center border=""  class="tableComent">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column property="planNo" width="180" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button btnCode="003M4E0400" v-if="btnFlg[3]" type="text" size="mini" @click="genzong(scope.row)">业务跟踪
              </el-button>
              <el-button btnCode="003M4E0500" v-if="btnFlg[4]" type="text" size="mini" @click="huowu(scope.row)">货物详情
              </el-button>

              <el-button btnCode="003M4E0700" v-if="btnFlg[6]" type="text" size="mini" @click="lookImg(scope.row)">查看凭证
              </el-button>

            </div>
          </template>

        </el-table-column>
        <el-table-column property="businessProgress" width="120" label="业务进度"></el-table-column>
        <el-table-column property="importance" width="100" label="重要度"></el-table-column>
        <el-table-column property="projectApprovalDate" width="120" label="立项日期"></el-table-column>
        <el-table-column prop="businessPersonnel" label="业务人员" width="120"></el-table-column>
        <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
        <el-table-column prop="demanderCustomer" label="需方客户" width="140"></el-table-column>
        <el-table-column prop="superiorOrderingCustomer" label="上级订货客户" width="140"></el-table-column>
        <el-table-column prop="subordinateSalesCustomer" label="下级销售客户" width="140"></el-table-column>
        <el-table-column prop="settlementCustomer" label="结算客户" width="140"></el-table-column>
        <el-table-column prop="source" label="客户/订单来源" width="140"></el-table-column>
        <el-table-column prop="deliveryTime" label="货物交付时间" width="120"></el-table-column>
        <el-table-column prop="requirementDescription" label="工艺要求简述" width="140"></el-table-column>
        <el-table-column prop="flowDirection" label="物流流向及方式" width="140"></el-table-column>
        <el-table-column prop="customerRequirements" label="客户其他要求" width="140"></el-table-column>
        <el-table-column prop="steelMill" label="钢厂" width="140"></el-table-column>
        <el-table-column prop="contractNumber" label="合同号" width="140"></el-table-column>
        <el-table-column prop="agreementNumber" label="合约号" width="140"></el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" width="100"></el-table-column>
        <el-table-column prop="planNumber" label="计划件数" width="100"></el-table-column>
        <el-table-column prop="singleWeight" label="单件重量（吨）" width="100"></el-table-column>
        <el-table-column prop="planWeight" label="计划吨数" width="100"></el-table-column>
        <el-table-column prop="createUser" label="创建人" width="100"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align: right;">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo" :page-sizes="[25, 50, 100]" :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog append-to-body :title="title" :visible.sync="imgMark" :close-on-click-modal="false" width="45%" center>
      <div>
        <el-upload action="" :auto-upload=false :multiple=true :file-list="imgList" :on-change="imgPreview"
          list-type="picture-card" accept="image/*" :limit="20" :disabled="delFlag" :on-preview="handlePictureCardPreview"
          :on-remove="GimgRemove" :class="[isAdd ? 'hidden' : '']">
        </el-upload>
        <span style="font-size:12px;color:red;" v-if="title == '上传凭证'">最多上传5张，支持jpg、png格式图片</span>

      </div>
      <span slot="footer" class="footerBtn" v-if="title == '上传凭证'">
        <el-button @click="imgMark = false">取消</el-button>
        <el-button type="primary" @click="imgOk()">确 定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer :zIndex='9999' v-if="dialogVisible" :on-close="closeViewer" :url-list="lookimgList" />
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {
  getBusinessManagementList,
  deleteBusinessManagement,
  businessUploadCredentials,
  getBusinessCredentials,
  deleteBusinessCredentials
} from '@/api/wms-stock'
import { compressImages } from '@/utils/compressImages'
export default {
  components: {
    ElImageViewer
  },
  data () {
    return {
      h: '500px',
      imgList: [],
      imgData: [],
      imgArr: [],
      lookimgList: [],
      dialogImageUrl: '',
      isAdd: false,
      dialogVisible: false,
      delFlag: false,
      title: '上传凭证',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      yxtj: {},
      row: {},
      tableList: [],
      selectionList: [],
      loading: 'false',

      total: 0,
      fileIsAdd: false,
      imgMark: false,
      dialogVisible: false,

      addvRFlist: [],
      sjh: '500',
      loading1: false,

      addFrom: {},
      dialogAdd: false,
      sijiList: [],
      SJtotal: 0,
      btnFlg: [],
      btnIdArr: [
        '003M4E0100',
        '003M4E0200',
        '003M4E0300',
        '003M4E0400',
        '003M4E0500',
        '003M4E0600',
        '003M4E0700',
        '003M4E0800',
        '003M4E0900'
      ]
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/management')

    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 168 + 'px'
  },
  methods: {
    closeViewer () {
      this.dialogVisible = false
    },
    imgPreview (file, fileList) {
      let that = this
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png|)$/
      if (regex.test(fileName.toLowerCase())) {
        console.log(fileList, 'fileList')
        that.lookimgList = []
        fileList.forEach((item, index) => {
          that.$set(that.lookimgList, index, item.url)
        })
        that.imgList = fileList

        if (fileList.length < 5) {
          that.isAdd = false
        } else {
          that.isAdd = true
        }
      } else {
        fileList.pop()
        that.$alert('不支持此类型', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      let that = this
      if (that.lookimgList.length == 0) {
        that.imgList.forEach((item, index) => {
          that.lookimgList.push(item.url)
        })
        that.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            that.lookimgList = that.lookimgList.slice(index).concat(that.lookimgList.slice(0, index))
            that.dialogVisible = true
          }
        })
      } else {
        that.lookimgList.forEach((item, index) => {
          if (item == file.url) {
            that.lookimgList = that.lookimgList.slice(index).concat(that.lookimgList.slice(0, index))
            that.dialogVisible = true
          }
        })
      }
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    delImg (item) {
      // let obj = this.imgList.find(item1 => item1.fileKeyUrl == item.fileKeyUrl)
      // console.log(this.imgList, 'this.imgList');
      // console.log(obj, '111');

    },
    GimgRemove (file, fileList) {
      if (file && file.status === 'success') {
        if (file.fileKeyUrl) {
          deleteBusinessCredentials({
            imgId: file.imgId // 变更图片表id
          })
            .then(res => {
              DonMessage.success('操作成功!')
            })
            .catch(err => {
              DonMessage.error(err.message)
            })
        }
      }
    },
    imgOk () {
      if (this.imgList.length == 0) {
        this.$alert('请上传凭证图片！', '系统提示')
        return
      }
      if (this.imgList.length > 5) {
        this.$alert('最多上传5张凭证图片！', '系统提示')
        return
      }

      let imgfile = new FormData()
      let numId = { id: this.row.id }
      imgfile.set('params', JSON.stringify(numId))
      let that = this
      let arr = []
      this.imgList.forEach(item => {
        if (!item.imgId) {
          arr.push(item)
        }
      })
      if (arr.length !== 0) {
        console.log(arr, 'arr')
        compressImages(arr, {
          width: 1000
        }).then(result => {
          console.log(result, 'result')
          result.forEach(item => {
            if (item.uid) {
              imgfile.append('files', item)
            }
          })
          that.save1(imgfile)
        })
      } else {
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.imgMark = false
      }
    },
    save1 (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      businessUploadCredentials(data).then(res => {
        loading.close()
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.imgMark = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    shangchuan (row) {
      if (this.selectionList.length !== 1) {
        this.$message({
          message: '请选择一条数据进行此操作',
          type: 'error'
        })
        return
      }
      this.title = '上传凭证'
      this.lookimgList = []
      getBusinessCredentials({
        id: this.selectionList[0].id
      })
        .then(res => {
          this.imgList = res
          this.imgArr = res

          if (res) {
            this.imgList.forEach((item, index) => {
              item.url = item.fileKeyUrl
            })
            if (this.imgList.length < 5) {
              this.isAdd = false
            } else {
              this.isAdd = true
            }
          } else {
            this.isAdd = false
          }
          this.fileIsAdd = true
          this.imgMark = true
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    lookImg (row) {
      this.imgList = []
      this.row = row
      this.title = '查看凭证'
      this.lookimgList = []

      getBusinessCredentials({
        id: row.id
      })
        .then(res => {
          if (res) {
            this.imgList = res
            this.imgArr = res
            this.imgList.forEach((item, index) => {
              item.url = item.fileKeyUrl
            })
            this.isAdd = true

            this.fileIsAdd = true
            this.imgMark = true
          } else {
            DonMessage.error('暂无凭证，请先上传!')
          }
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    addForm () {
      this.$router.push({
        name: 'managementAdd',
        query: {
          title: '新增业务'
        }
      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.selectionList = []
      this.selectionList = selection
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (this.searchFrom.createTime) {
        this.searchFrom.createTimeStart = this.searchFrom.createTime[0] + ' 00:00:00'
        this.searchFrom.createTimeEnd = this.searchFrom.createTime[1] + ' 23:59:59'
      } else {
        this.searchFrom.createTimeStart = null
        this.searchFrom.createTimeEnd = null
      }
      getBusinessManagementList(searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        loading.close()
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    // 货物详情
    huowu (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.$router.push({
        name: 'managementHuoWu',
        query: {
          addFrom: this.addFrom,
          id: this.addFrom.id,
          title: '货物详情'
        }
      })
    },
    // 修改
    genzong (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.$router.push({
        name: 'managementTrack',
        query: {
          addFrom: this.addFrom,
          id: this.addFrom.id,
          title: '业务跟踪'
        }
      })
    },
    // 修改
    change () {
      if (this.selectionList.length !== 1) {
        this.$message({
          message: '请选择一条数据进行此操作',
          type: 'error'
        })
        return
      }
      this.addFrom = JSON.parse(JSON.stringify(this.selectionList[0]))
      this.$router.push({
        name: 'managementAdd',
        query: {
          addFrom: this.addFrom,
          title: '修改业务'
        }
      })
    },
    saveFn (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          console.log(this.addFrom)
          this.addFrom.regionFlowId = this.addFrom.regionFlowName.id
          this.addFrom.regionFlowName = this.addFrom.regionFlowName.name
          rulePlanUpdate(this.addFrom)
            .then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        } else {
          return false
        }
      })
    },

    // 删除
    delFN () {
      if (this.selectionList.length !== 1) {
        this.$message({
          message: '请选择一条数据进行此操作',
          type: 'error'
        })
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          deleteBusinessManagement({ id: this.selectionList[0].id })
            .then(res => {
              loading.close()
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList(this.searchFrom)
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
        })
        .catch(() => { })
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null,
        createTimeStart: null,
        createTimeEnd: null
      }

      this.getList(this.searchFrom)
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null || cellValue == '') {
        str = '--'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}

.footerBtn {
  text-align: center;
  // margin-left: 40%;
}

.inpBox .el-date-editor {
  width: 350px !important;
}

// .imgBox {
//   display: flex;

//   .item {
//     display: flex;
//     width: 50%;
//     justify-content: space-around;
//   }

//   /deep/ .hide .el-upload--picture-card {
//     display: none;
//   }
// }

.el-tag {
  margin: 0 4px !important;
}

.liuxiang /deep/ .el-input__inner {
  width: 100%;
}

.liuxiang /deep/.el-select {
  width: 417px;
}

.imgBox {
  margin: 22px 10px;
}

.hidden /deep/.el-upload--picture-card {
  display: none;
}

.imgDialog /deep/.el-dialog__body {
  text-align: center;
}

/deep/.el-upload-list--picture-card .el-upload-list__item-actions {
  font-size: 30px;

  .el-upload-list__item-delete {
    margin-left: 30px;
  }
}
.formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
